import { FormatAmount } from "app/utils/utility.service";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Fragment } from "react";

const NetworthTable = ({
  reportData,
  loanData,
  showMore,
  showButton,
  handleShowMore,
  lastData,
  hidden
}) => {
 
  return (
    <div className="HomeValueTable mb-4 widthCls">
      {reportData && reportData.length > 0 && (
        <Fragment>
          <div className="flex">
            <h3 className="col-12 text-align-center">Networth Projection</h3>
          </div>
          <DataTable value={reportData} responsiveLayout="scroll">
            <Column field="year" header="Year" ></Column>
           
            {!hidden.realEstate && (
            <Column
              field="realEstate"
              header="Real Estate"
              body={(rowData) =>
                rowData.realEstate
                  ? FormatAmount((rowData.realEstate))
                  : "0"
              } 
            ></Column>
            )}
            {!hidden.stock && (
            <Column
              field="stockMarket"
              header="Stock Market"
              body={(rowData) =>
                rowData.stockMarket
                  ? FormatAmount((rowData.stockMarket))
                  : "0"
              } 
            ></Column>
              )}
                 {!hidden.commodities && (
            <Column
              field="commodities"
              header="Commodities"
              body={(rowData) =>
                rowData.commodities
                  ? FormatAmount((rowData.commodities))
                  : "0"
              } 
            ></Column>
             )}
             {!hidden.crypto && (
            <Column
              field="crypto"
              header="Cryptocurrency"
              body={(rowData) =>
                rowData.crypto ? FormatAmount((rowData.crypto)) : "0"
              } 
            ></Column>
             )}
             {!hidden.depletion && (
            <Column
              field="depletion"
              header="Depletion"
              body={(rowData) =>
                rowData.depletion
                  ? FormatAmount((rowData.depletion))
                  : "0"
              } 
            ></Column>
              )}
             {reportData.some(p => p.mortgage > 0) &&  <Column header="Mortgage" field="mortgage"   body={(rowData) =>
                rowData.mortgage
                  ? FormatAmount(rowData.mortgage)
                  : "0"
              } />}
              
               <Column
              field="netWorth"
              header="Net Worth"
              body={(rowData) =>
                rowData.netWorth
                  ? FormatAmount((rowData.netWorth))
                  : "0"
              } 
            ></Column>
          </DataTable>
          <div className="flex justify-content-end p-4">
            {showButton && (
              <Fragment>
                {!showMore ? (
                  <Button
                    className="p-button-raised p-button-warning mr-2"
                    onClick={handleShowMore}
                  >
                    Show More
                  </Button>
                ) : (
                  <Button
                    className="p-button-raised p-button-warning mr-2"
                    onClick={handleShowMore}
                  >
                    Show Less
                  </Button>
                )}
              </Fragment>
            )}
          </div>
          {!showMore && showButton && (
            <DataTable
              className="lastRow"
              value={lastData}
              responsiveLayout="scroll"
            >
              <Column header="Year" field="year"></Column>
            
                 {!hidden.realEstate && (
              <Column
                field="realEstate"
                header="Real Estate"
                body={(rowData) =>
                  rowData.realEstate
                    ? FormatAmount(parseInt(rowData.realEstate))
                    : "0"
                }
              ></Column>
                 )}
            {!hidden.stock && (
              <Column
                field="stockMarket"
                header="Stock Market"
                body={(rowData) =>
                  rowData.stockMarket
                    ? FormatAmount(parseInt(rowData.stockMarket))
                    : "0"
                } 
              ></Column>
               )}
                {!hidden.commodities && (
              <Column
                field="commodities"
                header="Commodities"
                body={(rowData) =>
                  rowData.commodities
                    ? FormatAmount(parseInt(rowData.commodities))
                    : "0"
                } 
              ></Column>
                )}
                   {!hidden.crypto && (
              <Column
                field="crypto"
                header="Cryptocurrency"
                body={(rowData) =>
                  rowData.crypto ? FormatAmount(parseInt(rowData.crypto)) : "0"
                } 
              ></Column>
                   )}
              {!hidden.depletion && (
            <Column
              field="depletion"
              header="Depletion"
              body={(rowData) =>
                rowData.depletion
                  ? FormatAmount((rowData.depletion))
                  : "0"
              } 
            ></Column>
              )}
              {reportData.some(p => p.mortgage > 0) &&  <Column header="Mortgage" field="mortgage"   body={(rowData) =>
                rowData.mortgage
                  ? FormatAmount(rowData.mortgage)
                  : "0"
              } />}
                <Column
                field="netWorth"
                header="Net Worth"
                body={(rowData) =>
                  rowData.netWorth
                    ? FormatAmount(parseInt(rowData.netWorth))
                    : "0"
                }
                
              ></Column>
            </DataTable>
          )}
          <div className="printSeparation"></div>
        </Fragment>
      )}
    </div>
  );
};
export default NetworthTable;
